import { makeCrewLoaderWithLineItemClaims, redirect } from '~/utils/routing';

export const { loader, useLoaderData: useAddressData } =
  makeCrewLoaderWithLineItemClaims(
    ({ context }) =>
      context.address ?? context.order.shippingAddress ?? redirect('./edit'),
  );
